import type { RequestStatus } from '@product-portal/shared';
import { STATUS_LABELS } from '@/lib/labels';
import { Pill } from './pill';

const STATUS_CLASSES: Record<RequestStatus, string> = {
  submitted: 'bg-status-submitted text-status-submitted-foreground',
  qualifying: 'bg-status-qualifying text-status-qualifying-foreground',
  qualified: 'bg-status-qualified text-status-qualified-foreground',
  planned: 'bg-status-planned text-status-planned-foreground',
  in_progress: 'bg-status-in-progress text-status-in-progress-foreground',
  delivered: 'bg-status-delivered text-status-delivered-foreground',
  // ADR-005 §3: their own pills (values in styles/theme.css).
  refused: 'bg-status-refused text-status-refused-foreground',
  duplicate: 'bg-status-duplicate text-status-duplicate-foreground',
};

/**
 * Status pill, the eight statuses of the lifecycle.
 * « En attente de réponse » is an indicator, never a status: it has no pill.
 */
export function StatusPill({ status }: { status: RequestStatus }) {
  return <Pill className={STATUS_CLASSES[status]}>{STATUS_LABELS[status]}</Pill>;
}

/** Kept for the screens of lot 2: every status has a pill now. */
export const RequestStatusPill = StatusPill;
